import React, {useState} from 'react'
import ChunkDiv from "../components/contents/ChunkDiv"
import { makeStyles } from "@material-ui/core/styles"
import DesktopWindow from "../components/DesktopWindow"
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import ReplayRoundedIcon from '@material-ui/icons/ReplayRounded';
import FastForwardRoundedIcon from '@material-ui/icons/FastForwardRounded';
import Fab from '@material-ui/core/Fab'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import SmoothScrolling from "../components/SmoothScrolling"
import Zoom from '@material-ui/core/Zoom';

const useStyles = makeStyles((theme) => ({
    terminalShell: {
        backgroundColor: "#2e3440",
        boxSizing: "border-box",
        color: "#eceff4",
        fontFamily: "'Fira Code', monospace",
        fontSize: "16px",
        height: "100%",
        lineHeight: "24px",
        overflowY: "auto",
        padding: "0",
        width: "100%",
        paddingBottom: "80px",
        minHeight: 500,
        '& em': {
            color: "#73c9ff"
        },
        '& code': {
            color: theme.palette.common.white,
            padding: "1px 5px",
            borderColor: "#848a99",
            backgroundColor: "#575d6b",
            '&:before': {
                backgroundColor: "transparent"
            }

        },
        '& strong': {
            color: theme.palette.secondary.light
        },
        '& a': {
            color: theme.palette.secondary.light
        },
        '& .terminal-response': {
            background: "#eea849",
            borderRadius: 2,
            padding: "4px 8px"
        },
        '& .blue': {
            color: "#73c9ff"
        },
        '& blockquote': {
            color: "#2e3440"
        },
        '& .gif-wrapper': {
            maxWidth: 500
        },
        '& .gif-wrapper-tall': {
            maxWidth: 250
        },
        '& p': {
            margin: "0 0 1.5em"
        }
    },
    buttonsWrapper: {
        marginBottom: 200,
        marginTop: 20
    },
    fabButton: {
        position: 'fixed',
        bottom: 20,
        '@media (max-width: 1024px)': {
            bottom: 68
        },
        left: '50%',
        marginLeft: '-28px',
        background: 'radial-gradient(circle, rgba(38,49,89,1) 0%, rgba(2,14,60,1) 100%)',
        border: '2px solid rgba(255,255,255,1)',
        zIndex: 1000
    },
}));

const RenegadeOSLiteView = (props) => {
    const classes = useStyles()
    const [showScrollDown, setShowScrollDown] = useState(false)

    const { handleButtonClick,
            completedChunks,
            showButtons,
            tw,
            getChosenButtonTextForChunk,
            logo,
            restartExperience,
            goToEnd
          } = props.data

    const _setShowScrollDown = (isVisible) => {
        let node = document.getElementById("activeChunk")
        if (node) {
            if (isVisible) {
                setShowScrollDown(false)
            }
            else {
                if (window.scrollY > (node.offsetTop + node.offsetHeight)) {
                    setShowScrollDown(false)
                }
                else {
                    setShowScrollDown(true)
                }
            }
        }
    }


    const getChunkDivs = () => {

        const components = completedChunks.map((chunk, i) => {
            const isActiveChunk = i === completedChunks.length - 1

            if (chunk) {
                return <ChunkDiv
                    key={i}
                    chunk={chunk}
                    showButtons={showButtons}
                    isActiveChunk={isActiveChunk}
                    handleButtonClick={handleButtonClick}
                    tw={tw}
                    logo={logo}
                    buttonText={getChosenButtonTextForChunk(chunk)}
                    buttonsAreVisibleCallback={_setShowScrollDown}
                />
            }

        })



        return [components]
    }

    const showGoToEndButton = () => {
        let answer = true
        completedChunks.forEach(chunk => {
            if (chunk.isLastChunk) {
                answer = false
            }
        })
        return answer
    }

    return (
        <React.Fragment>
            <DesktopWindow>
            <div className={classes.terminalShell}>
                <br/>
                {getChunkDivs()}
            </div>
            </DesktopWindow>
            <Grid container spacing={2} justify="center" alignItems="center" className={classes.buttonsWrapper}>
                <Grid item>
                    <Button
                        variant="outlined"
                        startIcon={<ReplayRoundedIcon />}
                        onClick={() => {
                            restartExperience()
                        }}
                        disabled={completedChunks.length === 1}
                    >
                        Restart
                    </Button>
                </Grid>
                    <Grid item>
                        <Button
                            variant="outlined"
                            startIcon={<FastForwardRoundedIcon />}
                            onClick={() => {
                                goToEnd()
                            }}
                            disabled={!showGoToEndButton()}
                        >
                            Go To End
                        </Button>
                    </Grid>
            </Grid>
            <Zoom in={showScrollDown}>
                <Fab
                    color="secondary"
                    size="large"
                    aria-label="scroll back to top"
                    className={classes.fabButton}
                    onClick={() => {
                        SmoothScrolling.scrollTo("buttons")
                    }}
                >
                    <KeyboardArrowDownIcon />
                </Fab>
            </Zoom>

        </React.Fragment>
    )
}

export default RenegadeOSLiteView
